<div
  *transloco="let t; read: 'add-action-plan-dialog'"
  class="xi-modal__container add-action-plan-dialog__container"
>
  <h2 class="xi-modal__title add-action-plan-dialog__title">
    {{ t('title') }}
  </h2>

  <div class="xi-modal__content add-action-plan-dialog__action-plan-table-wrapper">
    <app-action-plan-table
      mode="select"
      [selectedIds]="selectedIds"
      (select)="onSelect($event)"
    ></app-action-plan-table>
  </div>

  <div class="xi-modal__actions add-action-plan-dialog__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button [text]="t('add')" [disabled]="isAddDisabled" (onClick)="onAdd()">
    </xi-default-button>
  </div>
</div>
